import { api } from '../createApi';
import { onDocumentExtractionCacheEntryAdded } from '../subscriptions/documentExtractions';

api.enhanceEndpoints({
  endpoints: {
    subscribeToDocumentExtractions: {
      onCacheEntryAdded: onDocumentExtractionCacheEntryAdded,
    },
  },
});
